import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";

export default function AccountStatementBetDetailsError({
	setDetailsType,
}: {
	setDetailsType: Function;
}) {
	const { t } = useTranslation();

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					<div className="popup__title">
						{t<string>(
							"ACC_STATEMENT.BET_DETAILS.BET_SLIP_DETAILS"
						)}
					</div>

					<Button
						type="button"
						className="btn--square btn--square--xsml btn--primary--inverted"
						iconOnly={true}
						iconClassName="u-icon--sml u-icon--close"
						onClick={() => setDetailsType(false)}
					/>
				</div>
				<div className="popup__body">
					<InfoMessageComponent
						type={"danger"}
						message={t<string>(
							"ACC_STATEMENT.BET_DETAILS.ERROR_OCCURED"
						)}
					/>
				</div>
			</div>
		</div>
	);
}
